"use client";

import * as Sentry from "@sentry/nextjs";
import Link from "next/link";
import { useEffect } from "react";
import { reportClientError } from "@/lib/error-reporter-client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    void reportClientError(error, {
      surface: "global-error",
      digest: error.digest ?? null,
    });
    Sentry.captureException(error, {
      tags: {
        surface: "global-error",
      },
      extra: {
        digest: error.digest ?? null,
      },
    });
  }, [error]);

  return (
    <html lang="de">
      <body className="min-h-screen bg-[var(--site-bg)] text-[var(--site-ink)]">
        <main className="site-container flex min-h-screen items-center py-16">
          <div className="panel-surface mx-auto w-full max-w-3xl overflow-hidden px-6 py-10 text-center sm:px-10 sm:py-12">
            <p className="kicker mx-auto w-fit">Systemfehler</p>
            <h1 className="mt-5 text-4xl font-black tracking-tight sm:text-5xl">
              Die Anwendung ist in einen globalen Fehlerzustand gelaufen.
            </h1>
            <p className="mx-auto mt-5 max-w-2xl text-lg leading-8 text-[var(--site-muted)]">
              Das betrifft nicht nur die aktuelle Seite, sondern die App-Hülle selbst. Ein
              erneuter Versuch ist sinnvoll; wenn das nicht reicht, wechseln Sie zurück zur
              Startseite oder zur Plattform.
            </p>
            <p className="mt-6 text-sm font-semibold uppercase tracking-[0.18em] text-[var(--site-brand)]">
              {error.digest ? `Fehler-ID ${error.digest}` : "HTTP 500"}
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <button
                type="button"
                onClick={() => reset()}
                className="button-primary cursor-pointer px-5 py-3 text-sm"
              >
                Erneut versuchen
              </button>
              <Link href="/plattform" className="button-secondary px-5 py-3 text-sm">
                Zur Plattform
              </Link>
              <Link href="/" className="button-secondary px-5 py-3 text-sm">
                Zur Startseite
              </Link>
            </div>
          </div>
        </main>
      </body>
    </html>
  );
}
